module.exports = __webpack_public_path__ + "static/media/void.5c5daf50.PNG";